import { TableListItemProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: TableListItemProps = {
  options: [{ value: 'Hello', align: 'right', width: 80 }],
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as TableListItemProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      draggable: true,
      checkbox: true,
      checked: true,
      showDivider: true,
      options: [
        { value: 'Hello', align: 'right', width: 80 },
        { value: 'World', align: 'center', width: '40%' },
        { value: '!!!', align: 'left' },
      ],
    } as TableListItemProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
